import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaBottomNavigationComponent } from './bottom-navigation.component';

@NgModule({
    declarations: [GaBottomNavigationComponent],
    exports: [GaBottomNavigationComponent],
    imports: [
        CommonModule
    ]
})
export class GaBottomNavigationModule { }
